import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import PassengersFooter from "../components/footer/index.js";
import usePassengers from "./usePassengers.js";
const usePassengersDesktop = (props)=>{
    const { literals  } = props;
    const { passengerTitleLabel =''  } = literals ?? {};
    const { value , inputProps , disableIncrement , handleOnChange , handleOnSelectChange  } = usePassengers(props);
    const hasSelects = useMemo(()=>value?.adults?.options ?? value?.children?.options ?? value?.babies?.options ?? value?.majors?.options ?? value?.young?.options ?? value?.senior?.options ?? value?.umnr?.options, [
        value?.adults?.options,
        value?.babies?.options,
        value?.children?.options,
        value?.majors?.options,
        value?.senior?.options,
        value?.umnr?.options,
        value?.young?.options
    ]);
    const renderFooter = useCallback(({ close  })=>/*#__PURE__*/ _jsx(PassengersFooter, {
            onClick: close,
            literals: literals
        }), [
        literals
    ]);
    const basePanel = useMemo(()=>({
            width: hasSelects ? 450 : '100%',
            maxWidth: hasSelects ? '100%' : 320,
            header: passengerTitleLabel
        }), [
        hasSelects,
        passengerTitleLabel
    ]);
    return {
        value,
        inputProps,
        disableIncrement,
        handleOnChange,
        handleOnSelectChange,
        renderFooter,
        basePanel
    };
};
export default usePassengersDesktop;

//# sourceMappingURL=usePassengersDesktop.js.map